import { Reveal, ChapterHeader } from "./Reveal";
import { IMAGES } from "@/lib/scroll";

const GROUPS = [
  {
    title: "Children",
    text: "Paediatric work through play, a safe room where big feelings can be small enough to hold.",
  },
  {
    title: "Adolescents",
    text: "Support through identity, pressure and change, in a space that treats young people with respect.",
  },
  {
    title: "Adults",
    text: "Therapy for trauma, anxiety, depression and transition, and psychometric or psycho-legal assessment when clarity is needed.",
  },
];

export const WhoIWorkWith = () => (
  <section id="who" data-testid="who-section" className="py-24 md:py-32 bg-pawc-paper overflow-hidden">
    <div className="max-w-6xl mx-auto px-6">
      <ChapterHeader number="05" eyebrow="Who I Work With" title="Children, adolescents and adults" />

      <div className="grid md:grid-cols-12 gap-12 mt-14 items-center">
        <div className="md:col-span-7 space-y-6 order-2 md:order-1">
          {GROUPS.map((g, i) => (
            <Reveal key={g.title} delay={0.1 * i}>
              <div
                data-testid={`who-card-${i}`}
                className="rounded-2xl bg-pawc-sand border border-pawc-teal/10 p-7 md:p-8 md:ml-[calc(theme(spacing.8)*var(--i,0))]"
                style={{ "--i": i }}
              >
                <h3 className="font-serif text-2xl text-pawc-teal mb-2">{g.title}</h3>
                <p className="text-sm md:text-base text-pawc-slate leading-relaxed max-w-[55ch]">
                  {g.text}
                </p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.35}>
            <p className="text-xs md:text-sm text-pawc-slate italic pt-2">
              I also work with clients referred for psycho-legal / medico-legal
              assessment and reporting.
            </p>
          </Reveal>
        </div>

        <Reveal className="md:col-span-5 order-1 md:order-2" delay={0.15}>
          <div className="relative md:translate-y-6">
            <div className="absolute -bottom-4 -right-4 w-full h-full rounded-3xl bg-pawc-teal/10" aria-hidden="true" />
            <img
              src={IMAGES.waveCrest}
              alt="A clear blue wave cresting in open water"
              className="relative rounded-3xl w-full h-[380px] md:h-[480px] object-cover shadow-[0_25px_50px_-12px_rgba(14,95,115,0.15)]"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
